export enum AppRoles {
    Viewer = 'viewer', //Mag alles lezen maar niets aanpassen
    DataEntry = 'data-entry', //Mag fees en invoices invoeren en wijzigen
    DataEntryPlus = 'data-entry-plus', //Mag customers en beneficiaries invoeren en wijzigen
    Approver = 'approver', //Mag fees en invoices goedkeuren
    Payer = 'payer', //Mag betalingen doen (fees op status paid), mag beneficiaries goedkeuren
    Admin = 'admin', //Mag gebruikers toevoegen en rollen toekennen, mag stamdata wijzigen
}
